<div class="wrapper">
  <ng-container *ngIf="isSvgIcon; else normalIcon">
    <div class="svg-icon">
      <mat-icon svgIcon="{{ iconName }}"></mat-icon>
    </div>
  </ng-container>
  <ng-template #normalIcon>
    <div class="icon">
      <mat-icon inline>{{ iconName }}</mat-icon>
    </div>
  </ng-template>
  <div class="row">
    <ng-content></ng-content>
  </div>
</div>
